export default {
    "tagsCreateEditTag_success": "Etiqueta guardada",
    "tagsCreateEditTag_editTitle": "Editar etiqueta",
    "tagsCreateEditTag_createTitle": "Nueva Etiqueta",
    "tagsCreateEditTag_color": "Escoga Nombre y Color",
    "tagsCreateEditTag_label": "Nombre",
    "tagsCreateEditTag_nestUnder": "Anidar debajo",
    "tagsCreateEditTag_typeToSearch": "Escriba para buscar...",
    "tagsCreateEditTag_tag": "Etiqueta",
    "tagsCreateEditTag_vehicles": "Vehículos",
    "tagsCreateEditTag_drivers": "Conductores",
    "tagsCreateEditTag_landmarks": "Landmarks",
    "tagsCreateEditTag_users": "Usuarios",
    "tagsCreateEditTag_forms": "Formularios",
    "tagsCreateEditTag_dynamicForms": "Formularios Dinámicos",
    "tagsCreateEditTag_geofences": "Geofences",
    "tagsCreateEditTag_errorParentTag": "No puede agregar como padre al mismo tag",
    "tagsCreateEditTag_unit": "Unidades",
    "tagsCreateEditTag_account": "Cuentas",
};